import { Dispatch, SetStateAction } from 'react';
import { useMutation } from 'react-query';

import { errorMessage } from '@features/applications';
import {
  boostSocialRoute,
  enterpriseBoostLocationRoute,
  enterpriseGraphicRoute,
} from '@features/boostMyJobs/api/constants';
import axiosInstance from '@server/axiosInstance';

type enterpriseHiringGraphicProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const enterpriseHiringGraphic = ({
  setErrorText,
}: enterpriseHiringGraphicProps) => {
  const {
    mutate: requestGraphinc,
    isLoading: isRequestGraphincLoading,
  } = useMutation({
    mutationFn: (variables: {
      company_id: number | string | undefined;
    }) =>
      axiosInstance
        .post(enterpriseGraphicRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        setErrorText('');
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });

  return {
    requestGraphinc,
    isRequestGraphincLoading,
  };
};
